// extracted by css-extract-rspack-plugin
export default {"group":"eW8e6bezl9oxZKBZ"};